var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['nut-backtop', { show: _vm.backTop }],style:(_vm.styles),on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('div',{staticClass:"nut-backtop-main"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }